import { COLORS_CONFIG_BAR, DEFAULT_COLORS, TREEMAP_COLORS } from "@components/widgets/apacheEchart/Commons"
import _ from "lodash"

const MAP_COLORS_CONFIG = [
    {
        color: DEFAULT_COLORS[0],
        condition: '<=' as const,
        key: 'value',
        value: 60,
    },
    {
        color: DEFAULT_COLORS[2],
        condition: '>' as const,
        key: 'value',
        value: 60,
    },
    {
        color: DEFAULT_COLORS[1],
        condition: '>' as const,
        key: 'value',
        value: 80,
    },
]


export const widgetsTreemap: CommonWidget = {



    /**************************************************************************
     *                                TREEMAP
    ***************************************************************************/

    treemap: {
        title: ' ',
        position: [0, 0],
        size: [0, 0],
        config: {
            id: 'tree-map',
            type: 'treemap',
            maxItemSize: 70,
            minItemSize: 1,
            itemLabel: '',
            itemLabelFontSize: 15,
            removePadding: true,
            colors: TREEMAP_COLORS,
            decimals: 1,
            mapper: (data: any, extra: any) => {
                //console.log("MAPPER")
                //console.log(data)

                 return data.map((item: any,index: number) => ({
                   responseCount: 50,
                   value: item.value,
                   name: item.group,
                   index: index,
                   children: []
                   
                 }))
            },
            
            indicators: [
                {
                    indicator: 'FALTA',
                    keyExtract: ['value', 'group', 'count', 'geoCoordinates', 'group_0'],
                    value: 'value',
                    singleton: true,
                    /*extras: {
                        featureExclude: ['groupByTopLocation']
                    },
                    */
                },
            ],
        },
    },


}
